import { format } from 'date-fns';
import { COSTA_RICA } from 'src/constants/countryCode';

export type Shareholder = {
  firstName: string;
  lastName: string;
  gender: string;
  birthday: string;
  nationality: string;
  nationalityName: string;
  civilStatus: string;
  civilStatusName: string;
  idType: string;
  id: string;
  participationRate: string;
};

export type LegalBeneficiary = Shareholder & {
  relationship: string;
  relationshipName: string;
};

// For the customer's data
export type EmissionBaseFields = {
  // shared between Natural and Legal Person
  idType: string; // cedula, pasaporte or ruc
  email: string;
  phoneNumber: string;
  assignDateSignature: boolean;

  // Natural Person related data
  idNumber: string; // <-- This also houses the ruc when the customer is a legal entity
  names: string;
  lastNames: string;
  birthday: string;
  gender: string;
  enableInheritor: boolean;
  effectiveDate: string;
  birthPlace: string;
  birthPlaceName: string;
  nationality: string;
  nationalityName: string;
  otherNationality: string;
  otherNationalityName: string;
  civilStatus: string;
  civilStatusName: string;

  // Legal Person related data
  rucNumber: string; // <-- Note that this field is not used, ruc is inserted directly isnide idNumber
  legalEntityName: string;
  legalEntityCountry: string;
  legalEntityOccupation: string;

  // Creditor data
  creditorType: string;
  currentBank: string;
  creditAmount: number;

  // PEP
  pep?: boolean;
  bloodRelatedToPep?: boolean;
  cicac: boolean;
  pepLawArticle?: boolean;

  // occupation data
  profession: string;
  occupation: string;
  occupationName: string;
  enterprise: string;
  enterpriseActivity: string;
  salary: string;
  typeOfMoney: string;
  originCountry: string;
  originCountryName: string;
  originDetail: string;
  originType: string;
  // Added for funds origin legal person
  economicActivity: string;
  economicActivityName: string;

  // enterprise data
  socialReason: string;
  notificationPreference: string;
  fixNumber: string;

  // enterprise stock exchange data
  isInStockExchange: boolean;
  stockExchangeName: string;
  stockExchangeCountry: string;
  stockExchangeCountryName: string;
  companyType: string;

  // address data
  addressCountry: string;
  addressCountryName: string;
  addressState: string;
  addressStateName: string;
  addressCity: string;
  addressCityName: string;
  addressTownship: string;
  addressTownshipName: string;
  addressDetail: string;
};

type EmissionDataFields = EmissionBaseFields & {
  // shareholders
  shareholders: Shareholder[];
  // hasShareholders
  hasShareholders?: boolean;
};

export function makeEmptyEmissionDataFields(): EmissionDataFields {
  return {
    idType: '',
    email: '',
    phoneNumber: '',

    idNumber: '',
    names: '',
    lastNames: '',
    birthday: '',
    gender: '',
    enableInheritor: false,
    assignDateSignature: false,
    birthPlace: '',
    birthPlaceName: '',
    nationality: '',
    nationalityName: '',
    otherNationality: '',
    otherNationalityName: '',
    civilStatus: '',
    civilStatusName: '',

    legalEntityName: '',
    rucNumber: '',
    legalEntityCountry: '',
    legalEntityOccupation: '',

    creditorType: '',
    currentBank: '',
    creditAmount: NaN,

    pep: false,
    bloodRelatedToPep: false,
    cicac: false,
    pepLawArticle: false,
    effectiveDate: format(new Date(), 'dd/MM/yyyy'),

    profession: '',
    occupation: '',
    occupationName: '',
    enterprise: '',
    enterpriseActivity: '',
    salary: '',
    typeOfMoney: 'CRC',
    originCountry: '',
    originCountryName: '',
    originDetail: '',
    originType: '',
    economicActivity: '',
    economicActivityName: '',

    socialReason: '',
    fixNumber: '',
    notificationPreference: '',

    shareholders: [],

    hasShareholders: false,

    isInStockExchange: false,
    stockExchangeName: '',
    stockExchangeCountry: '',
    stockExchangeCountryName: '',
    companyType: '',

    addressCountry: COSTA_RICA,
    addressCountryName: '',
    addressState: '',
    addressStateName: '',
    addressCity: '',
    addressCityName: '',
    addressTownship: '',
    addressTownshipName: '',
    addressDetail: '',
  };
}

export default EmissionDataFields;
